<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <v-card class="pa-4 elevation-2">
          <v-card-title class="headline mb-2">
            {{ t("message.privacy.title") }}
          </v-card-title>
          <v-card-text>
            <p class="left-align">
              {{ t("message.privacy.lastUpdated") }}: {{ lastUpdated }}
            </p>
            <v-divider class="mb-4"></v-divider>
            <p class="left-align">{{ t("message.privacy.intro") }}</p>
            <ul class="left-align">
              <li>{{ t("message.privacy.item1") }}</li>
              <li>{{ t("message.privacy.item2") }}</li>
              <li>{{ t("message.privacy.item3") }}</li>
              <li>{{ t("message.privacy.item4") }}</li>
              <li>{{ t("message.privacy.item5") }}</li>
              <li>{{ t("message.privacy.item6") }}</li>
              <li>{{ t("message.privacy.item7") }}</li>
              <li>{{ t("message.privacy.item8") }}</li>
            </ul>
            <p v-if="state.features.premiumEnabled" class="left-align account-tools">
              {{ t("message.privacy.accountTools") }}
              <router-link to="/premium" class="account-tools-link">
                {{ t("message.premiumNav") }}
              </router-link>
            </p>
            <p class="left-align contact">
              Support: <strong>{{ contactEmail }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { inject } from "vue";

const DEFAULT_CONTACT_EMAIL = "support@onlygrades.no";

export default {
  name: "PrivacyPage",
  setup() {
    const state = inject("state");
    const contactEmail =
      (process.env.VUE_APP_CONTACT_EMAIL || DEFAULT_CONTACT_EMAIL).trim() ||
      DEFAULT_CONTACT_EMAIL;
    const lastUpdated = (process.env.VUE_APP_LEGAL_LAST_UPDATED || "2026-02-11")
      .trim();

    const t = (key) => {
      const keys = key.split(".");
      let value = state.translations[state.locale];
      keys.forEach((k) => {
        value = value?.[k];
      });
      return value ?? key;
    };

    return { t, contactEmail, lastUpdated, state };
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
  font-size: 2rem;
  color: var(--og-text);
  font-family: "Newsreader", serif;
}

.v-card {
  background: var(--og-surface) !important;
  border: 1px solid var(--og-border);
  border-radius: 18px !important;
  box-shadow: var(--og-shadow) !important;
}

.left-align {
  text-align: left;
  line-height: 1.6;
  color: var(--og-muted);
}

.contact {
  margin-top: 14px;
}

.account-tools {
  margin-top: 12px;
}

.account-tools-link {
  margin-left: 6px;
  color: var(--og-link);
  text-decoration: none;
}

.account-tools-link:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .v-card-title {
    font-size: 1.5rem;
  }
}
</style>
